<template>
  <div class="page-foot wd-100 bgc-eeeeee">
      <div class="wd-1200px mar-0auto" style="height:200px">
          <div class="mar-top40 mar-bottom40 pad-right40 bd-right-dedede fl-left">
              <p class="font18 c-333333">关于我们</p>
              <p class="font14 c-666666 mar-top15"><router-link :to="{path:'/about/aboutCenter'}">中心介绍</router-link></p>
              <p class="font14 c-666666 mar-top10"><router-link :to="{path:'/about/parkInv'}">园区招商</router-link></p>
              <p class="font14 c-666666 mar-top10"><router-link :to="{path:'/about/hatchEnpList'}">入孵企业</router-link></p>
          </div>
          <div class="mar-top40 mar-bottom40 pad-auto40 bd-right-dedede fl-left">
            <p class="font18 c-333333 ">联系我们</p>
            <p class="font14 c-666666  mar-top15">电话：{{phone}}</p>
            <p class="font14 c-666666  mar-top10">地址：{{address}}</p>
            <p class="font14 c-666666  mar-top10">电子邮箱：{{email}}</p>
          </div>
          <div class=" mar-top40 mar-bottom40 pad-auto40 bd-right-dedede fl-left">
              <img src="../../assets/img/common/foot_logo.png">
          </div>
          <div class="mar-top40 mar-bottom40 fl-left pad-left50 mar-left20 tac">
              <p class="font14 c-666666 mar-bottom5">微信公众号</p>
              <img src="../../assets/img/common/2wm.png" alt="">
          </div>
          <div class="mar-top40 mar-bottom40 fl-left pad-left50 mar-left20 tac">
              <p class="font14 c-666666 mar-bottom5">移动端</p>
              <img src="../../assets/img/common/2wm2.png" width="90">
          </div>
      </div>
      <div class="tac pad-10auto bd-top-ffffff c-999999"><a href="https://beian.miit.gov.cn" target="_blank">备案号：粤ICP备14070030号</a></div>
  </div>
</template>

<script>
	export default {
	  data () {
	    return {
	      phone:'',
	      address:'',
	      email:'',
	    }
	  },
	  mounted () {
	   this.$axios.get(this.global.url+'about/contacts').then( res => {
	     if(res.data){
	         this.phone = res.data.phone;
	         this.address = res.data.address;
	         this.email = res.data.email;
	     }
	   });
	  },
	}
</script>

<style scoped>
  @import '../../assets/font/iconfont.css';
  @import '../../assets/css/common-distance.css';
  @import '../../assets/css/common-default.css';
  @import '../../assets/css/common-color.css';
  @import '../../assets/css/topAndfoot.css';
  @import '../../assets/css/common-layout.css';
  @import '../../assets/css/layui.css';
  @import '../../assets/css/client.css';
</style>
